import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-uae-pass',
    template: '',
    styles: [],
    standalone: false
})
export class UaePassComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    this.redirectToCallback();
  }

  private redirectToCallback(): void {
    // Function to get query parameters from the URL
    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      return {
        code: params.get('code'),
        state: params.get('state'),
        docs: params.get('docs'),
        status: params.get('status'),
        signer_process_id: params.get('signer_process_id'),
      };
    };

    const getNewUrl = () => {
      const host = window.location.host;
      const protocol = window.location.protocol;
      const server = `${protocol}//${host}/public-pages/index.html#!`;

      const queryParams = getQueryParams();
      if (queryParams.docs && queryParams.docs.length > 0) {
        return `${server}/accounting/uaepass/callback?docs=${queryParams.docs}&status=${queryParams.status}&signer_process_id=${queryParams.signer_process_id}`;
      }
      return `${server}/accounting/uaepass/callback?code=${queryParams.code}&state=${queryParams.state}`;
    };

    // Construct the new URL
    const newUrl = getNewUrl();

    // Redirect to the new URL
    window.location.href = newUrl;
  }
}
